import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component'
import {ReaddataComponent} from './readdata/readdata.component'
import {CountrymasterComponent} from './countrymaster/countrymaster.component'
import {CurrencymasterComponent} from './currencymaster/currencymaster.component'
import { OnboardingComponent } from './onboarding/onboarding.component'
import {ChamasterComponent} from './chamaster/chamaster.component'
import { PortmasterComponent } from './portmaster/portmaster.component'
import { ContractsComponent } from './contracts/contracts.component';
import { NDAComponent } from './nda/nda.component';
import { AssignempComponent } from './assignemp/assignemp.component';
import { ExchangeComponent } from './exchange/exchange.component';
import { ClientFileUploadComponent } from './client-file-upload/client-file-upload.component';
import { BankgauranteeComponent } from './bankgaurantee/bankgaurantee.component';
import { OutputComponent } from './output/output.component';
import { BondComponent } from './bond/bond.component';
import {AntidumpingComponent } from './antidumping/antidumping.component';
import {CustomnotifyComponent } from './customnotify/customnotify.component';
import {EximComponent } from './exim/exim.component';
import { ImportpartmasterComponent } from './importpartmaster/importpartmaster.component';
import { PartsComponent } from './parts/parts.component';
import { EmployeeComponent } from './employee/employee.component';
import { LicensedetailsComponent } from './licensedetails/licensedetails.component';
import { DashboadComponent } from './dashboad/dashboad.component';
import { UserrightsComponent } from './userrights/userrights.component';
import { LicenseMEISComponent } from './license-meis/license-meis.component';
import { LicenseAASComponent } from './license-aas/license-aas.component';
import { AuditReportComponent } from './audit-report/audit-report.component';
import { UnitsMasterComponent } from './units-master/units-master.component';

const routes: Routes = [{
  path:'',component:LoginComponent},
{path:'readPNR',component:ReaddataComponent},
{ path: 'countrymaster', component: CountrymasterComponent },
{ path: 'currencymaster', component: CurrencymasterComponent },
{path:'onboarding',component:OnboardingComponent},
{ path: 'Chamaster', component: ChamasterComponent },
{ path: 'Portmaster', component: PortmasterComponent },
{path:'Contracts',component:ContractsComponent},
{path:'NDA',component:NDAComponent},
{path:'AssignEmp',component:AssignempComponent}, 
{path:'Exchange',component:ExchangeComponent},
{path:'ClientUpload',component:ClientFileUploadComponent },
{path:'Bank',component:BankgauranteeComponent},
{path:'Output',component:OutputComponent},
{path:'Bond',component:BondComponent},
{path:'Antidumping',component:AntidumpingComponent},
{path:'Customnotify',component:CustomnotifyComponent},
{path:'Exim',component:EximComponent},
{path:'ImportCSV',component:ImportpartmasterComponent},
{path:'Parts',component:PartsComponent},
{path:'Employee',component:EmployeeComponent},
{path:'License',component:LicensedetailsComponent},
{path:'Dashboard',component:DashboadComponent},
{path:'UserRights',component:UserrightsComponent},
{path:'LicenseMEIS',component:LicenseMEISComponent},
{path:'LicenseAAS',component:LicenseAASComponent},
{path:'AuditReport',component:AuditReportComponent},
{path:'units-master', component:UnitsMasterComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
